import React from 'react';
import { string, array } from 'prop-types';
import CollectionListItem from './CollectionListItem';

const propTypes = {
  collection: array.isRequired,
  staticPath: string.isRequired,
};

const defaultProps = {
  collection: [],
};

const CollectionList = ({ collection, staticPath }) => (
  <div className="collection-list">
    {collection.length > 0 &&
      collection.map(file => (
        <CollectionListItem key={file.id} staticPath={staticPath} {...file} />
      ))}
  </div>
);

CollectionList.propTypes = propTypes;
CollectionList.defaultProps = defaultProps;

export default CollectionList;
